<template>
  <div>
    <h1 class="text-2xl font-semibold mb-4">Participants</h1>
    <p>Manage and view participants here.</p>
  </div>
</template>
